import { render, staticRenderFns } from "./SelectCombobox.vue?vue&type=template&id=32d85020&scoped=true&"
import script from "./SelectCombobox.vue?vue&type=script&lang=js&"
export * from "./SelectCombobox.vue?vue&type=script&lang=js&"
import style0 from "./SelectCombobox.vue?vue&type=style&index=0&id=32d85020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d85020",
  null
  
)

export default component.exports